import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { Content } from '@monorepo/golab-generated'
import { AppAndLabComponent } from '../../../../shared/components/app-and-lab/app-and-lab.component'

@Component({
  selector: 'app-app-and-lab-content',
  templateUrl: './app-and-lab-content.component.html',
  styleUrls: ['./app-and-lab-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AppAndLabComponent],
})
export class AppAndLabContentComponent {
  @Input() content: Content | undefined
}
